// Kept apart so tests can mock the bare dynamic import, which Jest cannot
// resolve for runtime URLs.
export const importModule = (url: string): Promise<unknown> =>
  import(/* webpackIgnore: true */ url)
